/*
 * Copyright 2026 North Carolina State University
 */

import React, { useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import NewApplication from '../shared/NewApplication';
import SavedApplications from '../shared/SavedApplications';
import ProfileCompletionGate from '../shared/ProfileCompletionGate';
import '../../styles/Applications.css';

const Applications = ({ user }) => {
//   const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('new');

  // Handle section changes with proper routing
  const handleSectionChange = (section) => {
    setActiveSection(section);
    // Update URL without full page reload
    navigate(`/applications/${section}`, { replace: true });
  };

  const renderSection = () => {
    switch (activeSection) {
      case 'new':
        return <ProfileCompletionGate><NewApplication user={user} /></ProfileCompletionGate>;
      case 'saved':
        return <SavedApplications user={user} />;
      default:
        return <ProfileCompletionGate><NewApplication user={user} /></ProfileCompletionGate>;
    }
  };

  return (
    <div className="applications-container">
      <div className="sidebar">
        <h2>Applications</h2>
        <ul>
          <li>
            <button
              type="button"
              onClick={() => handleSectionChange('new')}
              className={activeSection === 'new' ? 'active' : ''}
              aria-current={activeSection === 'new' ? 'page' : undefined}
            >
              New Application
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => handleSectionChange('saved')}
              className={activeSection === 'saved' ? 'active' : ''}
              aria-current={activeSection === 'saved' ? 'page' : undefined}
            >
              Past Applications
            </button>
          </li>
        </ul>
      </div>
      <div className="content-area">
        {renderSection()}
      </div>
    </div>
  );
};

export default Applications;